import getCopy from "@syntensor/common/data/copy";

export function getMoaTooltip(componentType = "") {
  return componentType === "protein"
    ? getCopy("apps_tooltips_moa-protein-tooltip")
    : getCopy("moa-other-tooltip");
}
